
import { defineComponent, ref } from 'vue';
import { useRoute } from 'vue-router';
import {
  retrieveApproveInfo,
  getProcessLogList,
  getOpsApplyProcessLogList,
} from '@/api/project-service';
import type {
  // IManageProjectInstanceDetail,
  IManageProjectProcessNodeListItem,
  IManageRelativeProjectListItem,
  IManageProjectApplyRecord,
  IBackendOpsApplyProcessRes,
} from '@/api/project-service/type.d';
// import MonacoEditor from '@/components/monaco-editor/index.vue';
import ApprovalProcess from './components/approval-process/index.vue';
import EnclosurePreview from './components/enclosure-preview/index.vue';
import OperationalApprovalProcess from './components/operational-approval/index.vue';
import { formatTime } from '@toy/utils';
import { getLabelByVal } from '@/core/utils/index';
import {
  REVIEW_STATE_LIST,
} from '@/constant/project-service';

// interface IManageSpanMethondProps {
//   row: IManageRelativeProjectListItem;
//   // column: TableColumnCtx<IManageRelativeProjectListItem>;
//   rowIndex: number;
//   columnIndex: number;
// }

export default defineComponent({
  components: {
    // MonacoEditor,
    ApprovalProcess,
    EnclosurePreview,
    OperationalApprovalProcess,
  },
  setup() {
    const $route = useRoute();
    const serviceId = $route.params.serviceId as string;

    const approveDetail = ref({} as IManageProjectApplyRecord);
    const relativeProjectList = ref([] as IManageRelativeProjectListItem[]);
    // let instanceDetail = {} as IManageProjectInstanceDetail;
    const processNodeList = ref([] as IManageProjectProcessNodeListItem[]);
    const OperationalApprovalProcessList = ref([] as IBackendOpsApplyProcessRes);

    const approveDetailKeyMap = {
      recordId: {
        label: '记录id',
      },
      serviceId: {
        label: '服务id',
      },
      creatorName: {
        label: '申请人名称',
      },
      firstHeadOfBackend: {
        label: '后端服务负责人名称',
      },
      secondHeadOfBackend: {
        label: '后端服务备选负责人名称',
      },
      businessType: {
        label: '所属业务线',
      },
      department: {
        label: '所属部门',
      },
      groupName: {
        label: '所属小组',
      },
      serviceName: {
        label: '服务名称',
      },
      jarName: {
        label: 'Jar包名称',
      },
      serviceExplain: {
        label: '服务描述',
      },
      applyReason: {
        label: '申请原因',
      },
      databaseName: {
        label: '数据库名称',
      },
      projectRepositoryUrl: {
        label: '项目仓库地址',
      },
      gatewayRouting: {
        label: '网关路由',
      },
      demandResources: {
        label: '资源中间件',
      },
      environment: {
        label: '运行环境',
        formatter:
          (value: string) => (value ? value.split(',') : []),
      },
      exampleNum: {
        label: '部署实例个数',
      },
      finishTime: {
        label: '完成时间',
        formatter: (value: string) => formatTime(value),
      },
      remark: {
        label: '备注信息',
      },
      reviewState: {
        label: '审批状态',
        formatter: (value: string) => getLabelByVal(REVIEW_STATE_LIST, value),
      },
      instanceCode: {
        label: '审批实例编号',
      },
      serialNumber: {
        label: '申请编号',
      },
      createdTime: {
        label: '创建时间',
        formatter: (value: string) => formatTime(value),
      },
      revisedTime: {
        label: '更新时间',
        formatter: (value: string) => formatTime(value),
      },
    };

    const approvalProcessVisible = ref(false);
    const OperationalApprovalProcessVisible = ref(false);

    const detailDialogInfo = ref({
      visible: false,
      value: '',
      title: '',
    });
    // const handleShowInstanceDetail = () => {
    //   let value = '';
    //   try {
    //     value = JSON.stringify(instanceDetail);
    //   } catch (e) {
    //     console.error(e);
    //   }
    //   detailDialogInfo.value.visible = true;
    //   detailDialogInfo.value.value = value;
    //   detailDialogInfo.value.title = '实例详情';
    // };
    const spanFirstArr = ref([] as number[]);
    const spanSecondArr = ref([] as number[]);
    // 合并列计算
    const getSpanArr = () => {
      let span: number = 0;
      let spanSecond: number = 0;
      if (relativeProjectList.value.length === 1) {
        spanFirstArr.value[span] = 1;
        spanSecondArr.value[spanSecond] = 1;
      }
      if (relativeProjectList.value.length > 1) {
        relativeProjectList.value.reduce((pre, cur, index) => {
          if (index === 1) {
            spanFirstArr.value[span] = 1;
            spanSecondArr.value[spanSecond] = 1;
          }
          if (pre.projectName === cur.projectName) {
            spanFirstArr.value[span] += 1;
            if (pre.firstLevelMenu === cur.firstLevelMenu) {
              spanSecondArr.value[spanSecond] += 1;
            } else {
              spanSecond = index;
              spanSecondArr.value[index] = 1;
            }
          } else {
            span = index;
            spanSecond = index;
            spanFirstArr.value[index] = 1;
            spanSecondArr.value[index] = 1;
          }
          return cur;
        });
      }
    };

    const getapproveDetail = async () => {
      const { data } = await retrieveApproveInfo(serviceId);
      // console.log(data, 'data');

      approveDetail.value = {
        ...data.applyRecord,
        ...data,
      };
      relativeProjectList.value = data.associationInfoVos;
      getSpanArr();
      // instanceDetail = data.instanceDetail;
      const list = await getProcessLogList(serviceId);
      processNodeList.value = list.data;
      // console.log(processNodeList.value);
      // 运维审批日志
      const operationList = await getOpsApplyProcessLogList(serviceId);
      OperationalApprovalProcessList.value = operationList.data;
      console.log(OperationalApprovalProcessList, '运维操作日志');
    };

    // 合并表格行
    const arraySpanMethod = ({ rowIndex, columnIndex } : { rowIndex: number; columnIndex: number; }) => {
      if (columnIndex === 0) {
        return {
          rowspan: spanFirstArr.value[rowIndex] ?? 0,
          colspan: 1,
        };
      }
      if (columnIndex === 1) {
        return {
          rowspan: spanSecondArr.value[rowIndex] ?? 0,
          colspan: 1,
        };
      }
      return {
        rowspan: 1,
        colspan: 1,
      };
    };

    const init = () => {
      getapproveDetail();
    };
    init();

    return {
      approveDetail,
      relativeProjectList,
      approveDetailKeyMap,
      // handleShowInstanceDetail,
      detailDialogInfo,
      approvalProcessVisible,
      processNodeList,
      arraySpanMethod,
      OperationalApprovalProcessVisible,
      OperationalApprovalProcessList,
    };
  },
});
